import type { NavSectionProps, NavItemDataProps } from 'src/components/nav-section';

import { resolveNavIcon } from './resolve-nav-icon';

// ----------------------------------------------------------------------

/** 将单个菜单节点转为导航项（跳过按钮权限项） */
function mapMenuToNavItem(menu: MyApi.OutputMenuDto): NavItemDataProps | null {
  if (menu.type === 'button') {
    return null;
  }

  const children = (menu.children ?? [])
    .map(mapMenuToNavItem)
    .filter((item): item is NavItemDataProps => item !== null);

  const path = menu.path ?? children[0]?.path ?? '';
  if (!path && children.length === 0) {
    return null;
  }

  return {
    title: menu.title,
    path: path || '#',
    icon: resolveNavIcon(menu.icon),
    ...(children.length > 0 ? { children } : {}),
  };
}

/** 将接口菜单树转为侧栏导航数据结构 */
export function menusToNavData(menus: MyApi.OutputMenuDto[]): NavSectionProps['data'] {
  return menus
    .filter((menu) => menu.type === 'category')
    .map((category) => ({
      subheader: category.title,
      items: (category.children ?? [])
        .map(mapMenuToNavItem)
        .filter((item): item is NavItemDataProps => item !== null),
    }))
    .filter((section) => section.items.length > 0);
}
